import { LiquidatorEntityType } from "../../types/creationCloture/liquidatorType";

export const liquidatorInitialState: LiquidatorEntityType = {
    companyName: "",
    postalCode: "",
    city: "",
    address: "",
    additionalAddress: "",
    cities: []
}